import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { ThemeContext } from "styled-components";
import {
  useSiteContext,
  SiteLogoImage,
  defaultSite
} from "@americanbible/uikit";

import { SiteLinks } from "../SiteLinks";
import {
  StyledHeaderContainer,
  LogoContainer,
  StyledHeader,
  TitleContainer,
  IconContainer,
  Title
} from "./styles";

const Header = ({ hasParallels }) => {
  const theme = useContext(ThemeContext);
  const site = useSiteContext();
  const isDefaultLogo = site.logoImage.includes(defaultSite.logoImage);

  return (
    <StyledHeaderContainer>
      <StyledHeader hasParallels={hasParallels}>
        <TitleContainer>
          <Link to="/">
            <LogoContainer>
              <SiteLogoImage className={isDefaultLogo ? "default-logo" : ""} />
            </LogoContainer>
          </Link>
          {isDefaultLogo && (
            <Title key="title">
              <Link to="/">{theme.title}</Link>
            </Title>
          )}
          <IconContainer>
            <SiteLinks site={site} theme={theme} />
          </IconContainer>
        </TitleContainer>
      </StyledHeader>
    </StyledHeaderContainer>
  );
};

Header.propTypes = {
  hasParallels: PropTypes.bool.isRequired
};

export default Header;
